<template>
  <CSidebar
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    class="sideBarCustom"
  >
    <CSidebarBrand class="d-md-down-none">
      <div class="refreshCircle" @click="clearSessions()" style="cursor: pointer;width:40px;position: fixed;left: 0;text-align:center;height:40px;">
        <CIcon name="cil-reload" />
      </div>
      <label class="logoBig" style="font-size: 20px;font-family: 'Lucida Handwriting', monospace;width:100%;float:left;text-align:center;">ACE</label>
      <label class="logoSmall" style="width:100%;font-family: 'Lucida Handwriting', monospace;float:left;text-align:center;">ACE</label>
      <!-- <img class="logoBig" style="width:100px;" src="./../assets/images/imperial_logo_big.png" />
      <img class="logoSmall" style="width:50px;" src="./../assets/images/imperial_logo_big.png" /> -->
    </CSidebarBrand>
    <CRenderFunction flat :contentToRender="nav"/>
    <CSidebarMinimizer
      class="c-d-md-down"
      @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
export default {
  name: 'TheSidebar',
  props: ['locale'],
  data () {
    return {
      // minimize: false,
      nav: [],
      // show: 'responsive',
      buffor: [],
    }
  },
  computed: {
    show () {
      console.log(this.$store.state.sidebarShow)
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  },
  methods: {
    dropdown(data){
      let result = {
            _name: 'CSidebarNavDropdown',
            name: data['name'],
            route: data['href'],
            icon: data['icon'],
            _children: [],
      }
      for(let i=0; i<data['elements'].length; i++){
        if(data['elements'][i]['slug'] == 'dropdown'){
          console.log(data['elements'][i])
          result._children.push( this.dropdown(data['elements'][i]) );
        }else{
          result._children.push(
            {
                   _name:  'CSidebarNavItem',
                   name:   data['elements'][i]['name'],
                   to:     data['elements'][i]['href'],
                   icon:   data['elements'][i]['icon']
            }
          );
        }
      }
      return result;
    },
    clearSessions() {
      sessionStorage.clear()
      localStorage.clear()
      window.location.reload(true);
    },
    rebuildData(data){
      this.buffor = [{
        _name: 'CSidebarNav',
        _children: []
      }];
      for(let k=0; k<data.length; k++){
        switch(data[k]['slug']){
          case 'link':
            if(data[k]['href'].indexOf('http') !== -1){
              this.buffor[0]._children.push(
                  {
                      _name: 'CSidebarNavItem',
                      name: data[k]['name'],
                      href: data[k]['href'],
                      icon: data[k]['icon'],
                      target: '_blank'
                  }
              );
            }else{
              this.buffor[0]._children.push(
                  {
                      _name: 'CSidebarNavItem',
                      name: data[k]['name'],
                      to:   data[k]['href'],
                      icon: data[k]['icon'],
                  }
              );
            }
          break;
          case 'title':
            this.buffor[0]._children.push(
              {
                _name: 'CSidebarNavTitle',
                _children: [data[k]['name']]
              }
            );
          break;
          case 'dropdown':
            this.buffor[0]._children.push( this.dropdown(data[k]) );
          break;
        }
      }
      return this.buffor;
    },
    downloadSidebarData(){
      let self = this;
      let locale = 'en';
      if(typeof localStorage.locale !== 'undefined'){
        locale = localStorage.getItem("locale")
      }
      axios.get( this.$apiAdress + '/api/menu?token=' + localStorage.getItem("api_token") + '&locale=' + this.locale )
      .then(function (response) {
        self.nav = self.rebuildData(response.data);
      }).catch(function (error) {
        console.log(error)
        self.$router.push({ path: '/login' })
      });
    }
  },
  watch: {
    locale: function(newVal, oldVal) { // watch it
      this.downloadSidebarData()
    }
  },
  mounted () {
    this.$root.$on('toggle-sidebar', () => {
      const sidebarOpened = this.show === true || this.show === 'responsive'
      this.show = sidebarOpened ? false : 'responsive'
    })
    this.$root.$on('toggle-sidebar-mobile', () => {
      const sidebarClosed = this.show === 'responsive' || this.show === false
      this.show = sidebarClosed ? true : 'responsive'
    })
    this.downloadSidebarData()
  }
}
</script>
